import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../userContext/UserContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, isLoading } = useContext(UserContext);

  // Mostrar un indicador de carga mientras se verifica el usuario
  if (isLoading) {
    return <p>Cargando...</p>; // Puedes reemplazar esto con un spinner u otro componente
  }

  // Redirigir si no hay usuario autenticado
  if (!user) {
    return <Navigate to="/" />;
  }

  if (allowedRoles) {
    // Verificar si el usuario tiene alguno de los roles permitidos
    for (let role of allowedRoles) {
      if (user.perfil[role]) {
        // Si el usuario tiene el rol permitido, permitir el acceso
        return children;
      }
    }
  } else {
    // Si no se proporcionaron roles permitidos, permitir el acceso
    return children;
  }

  // Fallback: redirigir a la pantalla de inicio
  return <Navigate to="/check" />;
};

export default ProtectedRoute;
